import styled from "styled-components";

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(28, 28, 28, 0.32);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 15vh;
  z-index: 9999;
`;

export const Modal = styled.div`
  width: min(100%, 560px);
  max-height: 60vh;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0px 8px 24px rgba(28, 28, 28, 0.16);
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const InputRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 16px;
  border-bottom: 1px solid #e6e9ef;

  input {
    flex: 1;
    border: none;
    outline: none;
    font-size: 16px;
    color: #293142;
  }
`;

export const KbdHint = styled.kbd`
  font-size: 12px;
  color: #767c8f;
  background: #f4f6fb;
  border-radius: 4px;
  padding: 2px 6px;
`;

export const ResultsList = styled.div`
  overflow-y: auto;
  padding: 8px;
`;

export const ResultRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  border-radius: 8px;
  cursor: pointer;
  background: ${(props) => (props.$active ? "#f4f6fb" : "transparent")};

  span {
    font-size: 14px;
    color: ${(props) => (props.$active ? "#2c3875" : "#293142")};
    font-weight: ${(props) => (props.$active ? 600 : 400)};
  }
`;
